<template>
  <div class="has-rror" v-if="hasError">
    <!-- <div v-if="hasError">
      <h2>Oops! Something went wrong.</h2>
      
      <p>{{ error }}</p>
    </div> -->
    <div class="error">
      <div class="error-content">
        <div class="found">
          <img src="@/assets/mybox/home/unknown.png" alt="unknown" />
        </div>
        <div class="found-text">Unknown Error</div>
        <div class="found-reload-box">
          <div class="view-details" @click="ViewDetails">details</div>
          <div class="found-Reload" @click="resetError">Reload</div>
        </div>
      </div>
    </div>

    <my-TextPrompt :isShow="isShow" @hide="ViewDetails" title="Error">
      <div class="view-text">
        {{ error }}
      </div>
    </my-TextPrompt>
  </div>
  <div v-else>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasError: false,
      error: "",
      isShow: false,
    };
  },
  errorCaptured(error, vm, info) {
    this.hasError = true;
    this.error = error.stack || error;
    console.error("错误边界", error, info);
    // 返回 false 将阻止错误传播
    return false;
  },
  methods: {
    resetError() {
      console.log("重置错误");
      this.hasError = false;
      this.error = "";
      this.$router.push({ path: "/" });
    },
    Reload() {
      window.location.reload();
      this.hasError = false;
    },
    ViewDetails() {
      this.isShow = !this.isShow;
    },
  },
};
</script>
<style lang="scss" scoped>
.has-rror {
  .error {
    width: 100%;
    height: calc(100vh - 64px);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .error-content {
    font-size: 0.32rem;
    color: #5f5f5f;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .found {
      width: 3.44rem;
      height: 1.4rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .found-text {
      margin-top: 0.3rem;
    }
    .found-reload-box {
      display: flex;
      justify-content: center;
      align-items: center;
      div {
        margin-top: 0.3rem;
        margin-right: 0.2rem;
        padding: 0.1rem 0.3rem;
        width: fit-content;
        height: 0.72rem;
        background: #171718;
        border-radius: 27px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
      }
    }
  }
  .view-text {
    width: 100%;
    padding: 0.3rem;
    word-wrap: break-word;
    text-align: left;
    max-height: 7rem;
    overflow-y: scroll;
  }
}
</style>
